import axios from "axios";
import { GET_FOTOR_BASE_URL, getFacewowXAppId } from "@Common";


const service = axios.create({
    baseURL: GET_FOTOR_BASE_URL()
});

/**
 * 注销 Fotor 账号
 * @param token token
 * @returns
 */
export function cancelFacewowAccount(token: string) {
    return service({
        url: "/api/user/cancel-account",
        method: "get",
        headers: {
            "x-app-id": getFacewowXAppId(),
            Authorization: 'bearer ' + token
        },
    });
}

/**
 * 获取 Fotor 账号注销状态
 * @param token token
 * @returns
 */
export function getFacewowCancelStatus(token: string) {
    return service({
        url: "/api/user/cancellation",
        method: "get",
        headers: {
            "x-app-id": getFacewowXAppId(),
            Authorization: 'bearer ' + token
        },
        withCredentials: true,
    });
}

/**
 * 撤销 Fotor 账号注销申请
 * @param token token
 * @returns
 */
export function withdrawalDeleteFacewowAccount(token: string) {
    return service({
        url: "/api/user/undo-cancel",
        method: "delete",
        headers: {
            "x-app-id": getFacewowXAppId(),
            Authorization: 'bearer ' + token
        },
    });
}